export default __webpack_public_path__ + "static/media/delivery.82ce5e72.png";